<template>
    <div class="Page">
        <Header Act="0"></Header>
        <div class="MaxWid">
            <!-- <div class="Logo">
                <div class="LogoImg">
                    <img src="../../assets/img/logo.jpg" alt="">
                    <div class="LogoTxt">
                        <p>中国心理卫生协会</p>
                        <p>China Association for Mental Health</p>
                    </div>
                </div>
            </div> -->
            <div class="LoginDis">
                <div class="LoginImg">
                    <img src="../../assets/img/login.png" alt="">
                </div>
                <div class="LoginCont">
                    <div class="LoginTit">找回密码</div>
                    <div class="LoginItem">
                        <div class="LoginItemMsg">手机号</div>
                        <div class="LoginItemVal">
                            <input type="text" v-model="SetData.mobile" placeholder="请输入手机号">
                        </div>
                    </div>
                    <div class="LoginItem">
                        <div class="LoginItemMsg">密码</div>
                        <div class="LoginItemVal">
                            <input type="password" v-model="SetData.newpassword" placeholder="请输入密码">
                        </div>
                    </div>
                    <div class="LoginItem">
                        <div class="LoginItemMsg">确认密码</div>
                        <div class="LoginItemVal">
                            <input type="password" v-model="SetData.sucpassword" placeholder="请输入密码">
                        </div>
                    </div>
                    <Slideunlock :PhoneData="SetData.mobile" @Slide="ToggleCode" TypeData="resetpwd"></Slideunlock>
                    <div class="LoginBtn" @click="RetrieveSuc">提交</div>
                    <div class="LoginOther">
                        <div class="ColorBlue" @click="GoPage('/Login')">已有账号</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <el-dialog title="验证手机" :visible.sync="CodeBlon"  width="35%" :show-close="false">
            <div class="CommDig">
                <div>
                    <div class="LoginItem">
                        <div class="LoginItemMsg">手机号</div>
                        <div class="LoginItemVal Pad15">{{SetData.mobile}}</div>
                    </div>
                    <div class="LoginItem">
                        <div class="LoginItemMsg">验证码</div>
                        <div class="LoginItemVal">
                            <input type="text" v-model="SetData.captcha" placeholder="请输入验证码">
                            <div class="LoginItemCode" :class="{BgGary:CountTime!=60}" @click="GetCode">{{ShowTime}}</div>
                        </div>
                    </div>
                    <div class="DigBtns">
                        <div class="Btn" @click="CodeBlon = false">取消</div>
                        <div class="Btn Blue" @click="CodeBlon = false">确认</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import Slideunlock from '@/components/tools/slideunlock';
    export default {
        components: {Header,Footer,Slideunlock},
        data() {
            return {
                i:1,
                Dates: "",
                SetData:{},
                CodeBlon:false,
                CountTime:60,
                DomTime:"",
                ShowTime:"获取验证码",
            }
        },
        mounted() {
            // this.GetChart();
        },
        computed: {

        },
        methods: {
            ToggleNav(i){
                this.i=i
            },
            ToggleCode(str){
                if(str =="Suc"){
                    this.CodeBlon = !this.CodeBlon;
                }
            },
            RetrieveSuc(){
                var Quy  = JSON.parse(JSON.stringify(this.SetData));
                if(this.SetData.newpassword != this.SetData.sucpassword){
                    this.$message({ message: "密码输入不一致，请重新输入", type: 'error' });
                    return;
                }
                this.$post('api/user/resetpwd',Quy).then((res) => {
                    if (res.data.code == 1) {
                        // localStorage.setItem("User", JSON.stringify(res.data.data));
                        this.$message({ message: res.data.msg, type: 'success' });
                        this.GoPage('/Login');
                    }else{
                        this.$message({ message: res.data.msg, type: 'error' });
                    }
                })
            },
            GetCode(){
                if(this.ShowTime == "获取验证码"){
                      this.$post('api/sms/xinxie_send', {
                          mobile: this.SetData.mobile,
                          event:"resetpwd",
                      }).then((res) => {
                          if (res.data.code == 1) {
                              this.$message({ message: res.data.msg, type: 'success' });
                              this.ShowTime = this.CountTime+"s";
                              this.CountTime--;
                              this.DomTime = setInterval(() =>{
                                  if (this.CountTime == 0) {
                                      clearInterval(this.DomTime);
                                      this.ShowTime = "获取验证码"
                                      this.CountTime = 60;
                                  } else {
                                      this.ShowTime = this.CountTime+"s";
                                      this.CountTime--;
                                  }
                              },1000)
                          }else{
                              this.$message({ message: res.data.msg, type: 'error' });
                          }
                      })
                }
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }
    .Logo{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;
    }
    .LogoImg{
        display: flex;
        align-items: center;
        flex: 1;
    }
    .LogoImg img{
        width: 60px;
        margin-right: 20px;
    }
    .LogoTxt{
        line-height: 24px;
    }
    .MaxWid {
        max-width: 1080px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .LoginDis{
        margin: 50px 0;
        display: flex;
    }
    .LoginImg img{
        width: 450px;
        height: 450px;
    }
    .LoginCont{
        flex: 1;
        margin-left: 10%;
    }
    .LoginTit{
        margin-bottom: 10px;
        font-weight: 400;
        font-size: 30px;
        color: #555;
        text-align: center;
    }
    .LoginNav{
        display: flex;
        align-items: center;
        margin: 20px 0;
    }
    .LoginNavItem{
        flex: 1;
        padding: 10px 0;
        text-align: center;
        border-bottom: 1px solid #ccc;
        font-weight: 400;
        font-size: 20px;
        color: #666666;
        cursor: pointer;
    }
    .LoginNavItem:hover,
    .LoginNavItem.Act{
        background: #0385EB;
        color: #fff;
    }
    .LoginItem{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .LoginItemMsg{
        color: #666666;
        font-size: 16px;
        width: 65px;
        text-align: right;
    }
    .LoginItemMsg{
        padding: 15px 0;
    }
    .LoginItemVal{
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        flex: 1;
        margin-left: 20px;
    }
    .LoginItemVal input{
        padding: 15px;
        flex: 1;
    }
    .LoginItemVal.Pad15{
        padding: 15px;
    }
    .LoginItemVal .LoginItemCode{
        width: 200px;
        padding: 13px 0;
        color: #fff;
        background: #0385EB;
        text-align: center;
        cursor: pointer;
    }
    .LoginItemVal .LoginItemCode.BgGary{
        color: #fff;
        background: #bcbcbc;
        cursor: no-drop;
    }
    .LoginBtn{
        margin-top: 40px;
        padding: 15px 0;
        color: #fff;
        background: #0385EB;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
    }
    .LoginOther{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #666;
        font-size: 16px;
        margin-top: 10px;
    }
    .LoginOther div{
        cursor: pointer;
    }
    .LoginOther .ColorBlue{
        color: #0385EB;
    }
    .CommDig{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 60px 0 30px;
        overflow:auto;
    }
    .DigBtns{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .DigBtns .Btn{
        background-color: #f6faff;
        border-radius: 10px;
        border: solid 1px #d6e5ff;
        font-size: 16px;
        color: #2354f4;
        padding: 10px 40px;
        cursor: pointer;
    }
    .DigBtns .Btn:hover{
        box-shadow: 0 0 10px #b6d0ed;
    }
    .DigBtns .Btn.Blue{
        background-color: #027cfb;
        color: #fff;
        margin-left: 20px;
    }
    @media only screen and (max-width: 536px) {
       
    }
</style>